var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCa = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.331h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337zM288 279.704l32-16-16-7.999v-16l-32 16 16-32h-16l-16-24.001-16 24.001h-16l16 32-32-16v16l-16 7.999 32 16-7.999 16h32v24.001h16v-24.001h32z",
  fill: "#d80027"
})));

export default SvgCa;